import { daemonServiceControllerSchema } from "./service-contract.js";
import * as z$1 from "zod/v4";
//#region src/schemas/daemon/runtime-lease.ts
const DAEMON_RUNTIME_LEASE_SCHEMA_VERSION = 1;
const daemonRuntimeLeaseModeSchema = z$1.enum(["foreground", "background"]);
const daemonRuntimeLeaseSchema = z$1.strictObject({
	schema: z$1.literal("openmeld-daemon-runtime-lease-v1"),
	v: z$1.literal(1),
	generation: z$1.int().nonnegative(),
	bundleId: z$1.string().min(1),
	pid: z$1.int().positive(),
	mode: daemonRuntimeLeaseModeSchema,
	startedAt: z$1.string().min(1),
	updatedAt: z$1.string().min(1),
	heartbeatAt: z$1.string().nullable(),
	serviceController: daemonServiceControllerSchema,
	managedBySystemService: z$1.boolean()
});
//#endregion
export { DAEMON_RUNTIME_LEASE_SCHEMA_VERSION, daemonRuntimeLeaseModeSchema, daemonRuntimeLeaseSchema };

//# sourceMappingURL=runtime-lease.js.map